export default __webpack_public_path__ + "static/media/house-solid-full.92e573c7.svg";